import { Fragment, useMemo, useRef } from 'react';

import { useUnleash } from '@/package';
import { useLabelingBoxContext } from '@/provider';
import { usePcdRenderingStore } from '@/store';
import { type NEW__LabelingBox } from '@/util';

import { BoxArrowHelper } from './BoxArrowHelper';
import { useToolPcdCanvasContext } from './hook';

const ToolPcdCanvasBoxList = ({ renderedIndex }: { renderedIndex: number }) => {
  const { isViewMode } = useToolPcdCanvasContext();

  return (
    isViewMode &&
    isViewMode.default && <DefaultPrimitiveList renderedIndex={renderedIndex} />
  );
};

const DefaultPrimitiveList = ({ renderedIndex }: { renderedIndex: number }) => {
  const { isEnabled } = useUnleash();
  const { labelingBoxList, visibleArrowHelper } = useLabelingBoxContext();
  const pcdIndex = usePcdRenderingStore(state => state.pcdIndex);
  const prevBoxListRef = useRef<NEW__LabelingBox[]>([]);
  const boxList = useMemo(() => {
    if (pcdIndex !== renderedIndex || pcdIndex === -1)
      return prevBoxListRef.current;
    // eslint-disable-next-line react-hooks/refs
    else prevBoxListRef.current = labelingBoxList;

    return prevBoxListRef.current;
  }, [labelingBoxList, pcdIndex, renderedIndex]);

  const isVisibleArrowEnabled = isEnabled(
    'vuex.sapporo.visibleArrowInLabelingTool',
  );

  const defaultPrimitiveList = useMemo(
    () =>
      // eslint-disable-next-line react-hooks/refs
      boxList.map((box, index) => {
        return (
          <Fragment key={box.id ?? index}>
            <primitive object={box.boxMesh} />
            <primitive object={box.line2} />
            {isVisibleArrowEnabled && visibleArrowHelper && (
              <BoxArrowHelper box={box} />
            )}
          </Fragment>
        );
      }),
    [boxList, isVisibleArrowEnabled, visibleArrowHelper],
  );

  return <>{defaultPrimitiveList}</>;
};

export default ToolPcdCanvasBoxList;
